import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const RemoveMemberFromWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMemberFromWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idOrganization"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"member"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberOrEmail"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMemberFromWorkspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idOrganization"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"member"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"RemoveMemberFromWorkspace","document":RemoveMemberFromWorkspaceDocument}} as const;
export type RemoveMemberFromWorkspaceMutationVariables = Types.Exact<{
  idOrganization: Types.Scalars['ID']['input'];
  member: Types.MemberOrEmail;
  traceId: Types.Scalars['String']['input'];
}>;


export type RemoveMemberFromWorkspaceMutation = (
  { __typename: 'Mutation' }
  & { removeMemberFromWorkspace?: Types.Maybe<(
    { __typename: 'RemoveMembersFromWorkspace_Response' }
    & Pick<Types.RemoveMembersFromWorkspace_Response, 'success'>
  )> }
);

export type RemoveMemberFromWorkspaceMutationFn = Apollo.MutationFunction<
  RemoveMemberFromWorkspaceMutation,
  RemoveMemberFromWorkspaceMutationVariables
>;

/**
 * __useRemoveMemberFromWorkspaceMutation__
 *
 * To run a mutation, you first call `useRemoveMemberFromWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberFromWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberFromWorkspaceMutation, { data, loading, error }] = useRemoveMemberFromWorkspaceMutation({
 *   variables: {
 *      idOrganization: // value for 'idOrganization'
 *      member: // value for 'member'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useRemoveMemberFromWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveMemberFromWorkspaceMutation,
    RemoveMemberFromWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveMemberFromWorkspaceMutation,
    RemoveMemberFromWorkspaceMutationVariables
  >(RemoveMemberFromWorkspaceDocument, options);
}
export type RemoveMemberFromWorkspaceMutationHookResult = ReturnType<
  typeof useRemoveMemberFromWorkspaceMutation
>;
export type RemoveMemberFromWorkspaceMutationResult =
  Apollo.MutationResult<RemoveMemberFromWorkspaceMutation>;
export type RemoveMemberFromWorkspaceMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveMemberFromWorkspaceMutation,
    RemoveMemberFromWorkspaceMutationVariables
  >;
